import { HighlightedFeedbackText } from '@modules/feedback/components/FeedbackHighlighter/HighlightedFeedbackText';
import { Highlight } from '@modules/feedback/types';
import { useIsFeedbackRedesignEnabled } from '@modules/feedbackV2/common/hooks';
import { PersonOutlineRounded } from '@mui/icons-material';
import { Stack, Typography, TypographyVariant } from '@mui/material';

interface AudioTranscriptTextProps {
  index: number;
  text: string;
  highlights: { [key: string]: Highlight[] };
  showOriginalLanguage: boolean;
  actorName?: string;
  variant?: TypographyVariant;
}

const AudioTranscriptText = ({
  index,
  text,
  highlights,
  showOriginalLanguage,
  actorName,
  variant = 'body1',
}: AudioTranscriptTextProps) => {
  const isFeedbackRedesignEnabled = useIsFeedbackRedesignEnabled();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={1}
      width="100%"
    >
      <Stack
        direction="row"
        spacing={1}
        textAlign="start"
        width="100%"
        textTransform="none"
      >
        {actorName && (
          <Stack
            direction="row"
            alignItems="center"
            columnGap={0.5}
            flexShrink={0}
          >
            {isFeedbackRedesignEnabled && (
              <PersonOutlineRounded
                fontSize="small"
                sx={{
                  color: 'text.secondary',
                }}
              />
            )}
            <Typography
              variant={variant}
              color="text.secondary"
              fontWeight="bold"
            >
              {actorName}:
            </Typography>
          </Stack>
        )}
        <Typography
          variant={variant}
          sx={{
            wordBreak: 'break-word',
            width: '100%',
            color: 'text.primary',
            whiteSpace: 'pre-line',
          }}
        >
          <HighlightedFeedbackText
            text={text}
            highlights={highlights[index]}
            msgIndex={index}
            showOriginalLanguage={showOriginalLanguage}
          />
        </Typography>
      </Stack>
    </Stack>
  );
};

export default AudioTranscriptText;
